namespace $.$$ {

	/** Публичный реестр пользователей (для обнаружения и пуш-сервиса). */
	export class $bog_gram_users extends $giper_baza_dict.with({
		/** Название реестра: задаёт создатель, видят все. */
		Title: $giper_baza_atom_text,
		Lords: $giper_baza_list_str,
		/** Публичные ключи участников, ключ словаря — лорд участника. Со
		 * скачанным реестром диалог заводится без сети: одного идентификатора
		 * для шифрованного ленда мало, нужен сам ключ. */
		Keys: $giper_baza_dict_to( $bog_gram_key ),
	}) {}

}
